import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      hidden: true,
      finishLoading: false
    }
  },
  computed: {
    ...mapGetters({
      isLoading: "isLoading",
    }),
    ...mapGetters('classification', {
      classification: 'classification'
    }),
    years() {
      return Math.floor(this.classification.seniority / 12)
    },
    month() {
      return this.classification.seniority % 12
    }
  },
  async created() {
    await this.refresh().then(() => this.finishLoading = true)
  },
  methods: {
    ...mapActions('classification', {
      refresh: 'REFRESH'
    }),
    // getListCondition(conditions) {
    //   return conditions.filter(item => item.id)
    // }
  }
}